import { Component, Input, OnInit, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-table-email-address-display',
  templateUrl: './table-email-address-display.component.html',
  providers: []
})

export class TableEmailAddressDisplayComponent implements OnInit, OnDestroy {

  /**
   * Email address name Id to use for display
   */
  @Input() emailAddressNameUuid: number

  /**
   * Email addresses
   */
  @Input() emailAddresses: any

  /**
   * Display
   */
  public display: boolean

  /**
   * Subscriptions
   */
  private subscriptions: Array<Subscription> = []

  /**
   * First item
   */
  public firstItem: any

  /**
   * Constructor
   */
  public constructor () {}

  /**
   * Ng on init
   */
  public ngOnInit (): void {
    this.display = false

    // Make sure we have a display order for sorting.
    this.emailAddresses.map((emailAddress) => {
      if (!emailAddress.emailAddressName) {
        emailAddress.emailAddressName = {
          displayOrder: 999
        }
      }
    })

    if (this.emailAddresses && this.emailAddresses.length > 0) {
      this.emailAddresses.sort((a, b) => a.emailAddressName.displayOrder - b.emailAddressName.displayOrder)
    }

    this.firstItem = this.emailAddresses.find((x) => x.emailAddressNameUuid === this.emailAddressNameUuid)

    if (!this.firstItem && this.emailAddresses && this.emailAddresses.length > 0) {
      this.firstItem = this.emailAddresses[0]
    }

    if (this.emailAddresses.length > 0) {
      this.display = true
    }
  }

  /**
   * On destroy
   */
  public ngOnDestroy (): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

}
